export default __webpack_public_path__ + "static/media/info-salud-mental.f43d2a56.svg";